module.exports = __webpack_public_path__ + "static/media/logoCompact.4319d863.svg";